import { z } from 'zod';
import { BaseUserDTOSchema } from "./users.dto.js";
export const UpdateUserInputDTOSchema = BaseUserDTOSchema.pick({
    id: true,
    name: true,
    email: true,
});
export const UpdateUserRequestDTOSchema = z.object({
    params: z.object({
        userId: UpdateUserInputDTOSchema.shape.id,
    }),
    body: UpdateUserInputDTOSchema.omit({ id: true }),
});
//# sourceMappingURL=update-user.dto.js.map